import api from '../../lib/api';
import type {
  CreateFormTaxonomyPayload,
  FormTaxonomyFlat,
  FormTaxonomyMenuResponse,
} from './types';

const ROLE_LIST_MAX = 32;

export async function fetchTaxonomiesMenu(roles?: string[]): Promise<FormTaxonomyMenuResponse> {
  const params: Record<string, string> = {};
  if (roles && roles.length > 0) {
    params.roles = roles.slice(0, ROLE_LIST_MAX).join(',');
  }
  const { data } = await api.get<FormTaxonomyMenuResponse>('form-taxonomies/menu', { params });
  return data;
}

/** Taxonomías activas para anclar libros (requiere workbooks.create, sin filtro por rol). */
export async function fetchTaxonomiesForWorkbookPin(): Promise<FormTaxonomyMenuResponse> {
  const { data } = await api.get<FormTaxonomyMenuResponse>('form-taxonomies/workbook-pin-options');
  return data;
}

export async function fetchFormTaxonomiesList(): Promise<FormTaxonomyFlat[]> {
  const { data } = await api.get<{ data: FormTaxonomyFlat[] }>('form-taxonomies');
  return data.data;
}

export async function createFormTaxonomy(
  payload: CreateFormTaxonomyPayload,
): Promise<FormTaxonomyFlat> {
  const { data } = await api.post<{ data: FormTaxonomyFlat }>('form-taxonomies', payload);
  return data.data;
}
